import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import EditorialContainer from 'brastrap/editorial/editorial-container/EditorialContainer';
import { sizeQuizMessages as messages } from '../../data/messages';
import { dataLayerGA4SizeQuizStageNumber } from '../../../shared/utils/data-layer';

const UnsuccessfulStage = ({
  contactData,
  intl: { formatMessage },
  displayQuiz,
}) => {
  useEffect(() => {
    dataLayerGA4SizeQuizStageNumber('No Results Page');
  }, []);

  return (
    <div className="stage stage-default">
      <div className="wrap">
        <h2 className="fullWidth">{formatMessage(messages.noSizeh2)}</h2>
        <p>{formatMessage(messages.noSizepara1)}</p>
        <p>{formatMessage(messages.noSizepara2)}</p>
        {displayQuiz && (
          <div className="c-footer__channels">
            <EditorialContainer containers={contactData} />
          </div>
        )}
      </div>
    </div>
  );
};

export default injectIntl(UnsuccessfulStage);

UnsuccessfulStage.propTypes = {
  contactData: PropTypes.array,
  displayQuiz: PropTypes.bool,
  intl: intlShape,
};
